import { setTerms } from './helpers';

export const setGarageStatus = setTerms('garage_status');
